export const sampleText = (type) => {
  if (type === "PARTNER_CODE_GROUP") {
    return "CODE001\nCODE002\nCODE003\nCODE004\nCODE006\nCODE007\nCODE008\nCODE009\nCODE010";
  }
  return "CODE001,4\nCODE002\nCODE003,\nCODE004,1\nCODE006\nCODE007,10\nCODE008,20\nCODE009,\nCODE010,100";
};
